var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gear-wrapper",style:({width: _vm.width, height: _vm.height})},[_c('img',{class:['gear', _vm.rotate ? 'rotate':'', _vm.rotateReverse ? 'rotate-reverse' : ''],attrs:{"src":_vm.gear,"alt":""}}),_c('img',{staticClass:"gear-u-cute",attrs:{"src":_vm.gearText,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }